// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2nIEi","amount":"Amount_amount__pGeb6","tip":"Amount_tip__3p4X0","tipHeader":"Amount_tipHeader__wXS3F","tipsWrap":"Amount_tipsWrap__32PYW"};